<template>
  <v-row class="my-3" no-gutters align="center" justify="center">
    <span class="d-block mr-1 caption">{{ text }}</span>
    <a class="mt-1" href="https://www.piriod.com/" target="_blank"><img :src="require(`@/assets/appLogo-color--Onlight.svg`)" alt="logo Piriod" height="16"></a>
  </v-row>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'con la tecnología de'
    }
  }
}
</script>